<template>
  <div :style="{ width: width, height: height }" ref="box"></div>
</template>

<script>
import * as echarts from "echarts/core";
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from "echarts/components";
import { LineChart, BarChart, PieChart, GaugeChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { EleResize } from "@/utils/esresize";
echarts.use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  LineChart,
  CanvasRenderer,
  BarChart,
  PieChart,
  GaugeChart,
]);
export default {
  name: "echarts-vue",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    notMerge: Boolean,
    height: {
      type: String,
      default: "400px",
    },
    options: {
      type: Object,
      required: true,
    },
    loginOptions: {
      type: Object,
      default: function () {
        return {
          text: "loading",
          color: "#4bc22a",
          textColor: "#000",
          maskColor: "rgba(255, 255, 255, 0.8)",
          zlevel: 0,
          monthList: [],
        };
      },
    },
  },
  watch: {
    width: {
      handler: function () {
        this.$nextTick(() => {
          this.charts.resize();
        });
      },
    },
    height: {
      handler: function () {
        this.$nextTick(() => {
          this.charts.resize();
        });
      },
    },
    options: {
      handler: function (val) {
        if (JSON.stringify(val) === "{}") {
          this.charts.showLoading(this.loginOptions);
        } else {
          this.charts.hideLoading();
          this.charts.setOption(val, this.notMerge);
        }
      },
      deep: true,
    },
  },
  methods: {
    init() {
      this.charts = echarts.init(this.$refs.box);
      this.$nextTick(() => {
        if (JSON.stringify(this.options) === "{}") {
          this.charts.showLoading(this.loginOptions);
        } else {
          this.charts.setOption(this.options, this.notMerge);
          let that = this;
          let listener = function () {
            that.charts.resize();
          };
          EleResize.on(this.$refs.box, listener);
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>

<style scoped></style>
